module.exports = {
  selectedViewLanguage: "selectedViewLanguage",
  fsiToken: "fsiToken",
};
